import { Pipe, PipeTransform } from '@angular/core';
import { VIEW_TYPE } from '../../core/constants/view-type.enum';

@Pipe({
    name: 'requestListEmptyStateMessage'
})
export class RequestListEmptyStateMessagePipe implements PipeTransform {
    transform(viewType: string | undefined): any {
        switch (viewType) {
            case VIEW_TYPE.NEW_REQUESTS:
                return 'noNewRequestMsg';
            case VIEW_TYPE.RETURNED_REQUESTS:
                return 'noReturnedRequestMsg';
            case VIEW_TYPE.ASSIGNED_TO_ME_REQUESTS:
                return 'noAssignedRequestMsg';
            case VIEW_TYPE.INPROGRESS_REQUESTS:
                return 'noInProgressRequestMsg';
            case VIEW_TYPE.COMPLETED_REQUESTS:
                return 'noCompletedRequestMsg';
            default:
                return 'noDataAvailable';
        }
    }
}
